import {
  useGetPreventaById,
  useGetProspectoByIdProspecto,
} from "@/shared/actions/erp";
import { useParams } from "react-router-dom";
import { LoaderComponent } from "@/shared/components/ui";
import { hasPermission } from "@/shared";
import { PermissionsEnum } from "@/auth/interfaces";
import SavePreventa from "../../shared/component/SavePreventa/SavePreventa";

///* Solo supervisor puede editar una preventa

export default function PreventaEditPage() {
  hasPermission(PermissionsEnum.api_change_preventa);

  const { idpreventa, idprospecto } = useParams();

  const { data, isLoading } = useGetProspectoByIdProspecto(idprospecto!);

  const { data: dataPreventa, isLoading: isLoadingPreventa } =
    useGetPreventaById(idpreventa!);

  if (isLoadingPreventa || isLoading) return <LoaderComponent />;

  if (!dataPreventa || !data) return null;

  return (
    <SavePreventa
      dataProspecto={data}
      dataPreventa={dataPreventa}
      editSupervisor={true}
    />
  );
}
